import packageMetadata from '../package.json';

export const appVersion = packageMetadata.version;
export const appEnvironment = process.env.REACT_APP_ENV || 'LOCAL';
export const appBuild = process.env.REACT_APP_BUILD || 'development';

export const appVersionLabel = `Version ${appVersion} · ${appEnvironment} · Build ${appBuild}`;
